import React from 'react';

import { useForm } from 'components/form';
import { RHP } from 'providers';
import * as Page from 'components/page';

import { StartupStep7AddForm } from './StartupStep7AddForm';

export function StartupStep7Add(props) {
    const { vars, postStartupRelationship } = props.useRankingStartup;
    const { ranking } = vars;
    const currDate = new Date();

    // Initialize a new form handler
    const form = useForm({
        year: currDate.getFullYear(),
        otherContact: false,
    });

    // Check for previous step conclusion
    if (!vars.application.steps || vars.application.steps.step5 !== true) {
        RHP.replace('/ranking/br/startup/');
        return null;
    }

    // Handle form submitions
    const onSubmit = values => {
        const payload = {
            year: values.year,
            programName: values.programName,
            description: values.description,
            linkUrl: values.linkUrl,
            ranking,
            company: {
                name: values.companyName,
                contact: {
                    name: values.ecosystemContactName,
                    email: values.ecosystemContactEmail,
                },
            },
        };
        // Add relationship
        return postStartupRelationship(payload)
            .then(() => RHP.push('/ranking/br/startup/step7'))
            .catch(() => form.submited());
    };

    const propsForm = { ...props, form, onSubmit };
    return (
        <Page.Page name="StartupStep7Add">
            <Page.Title>{props.t('StartupStep7Add.title')}</Page.Title>
            <Page.Descr>{props.t('StartupStep7Add.descr')}</Page.Descr>

            <StartupStep7AddForm {...propsForm} />
        </Page.Page>
    );
}
export default StartupStep7Add;
